import * as React from "react";
import MuiTabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Card from "./Card";
import { Alert, AlertTitle, Chip } from "@mui/material";
import Margin from "./Margin";
import { Results } from "../App";
import { formatAmount } from "../utils";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

interface Props {
  results: Results
}

const Tabs:React.FC<Props> = ({results}) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <MuiTabs value={value} centered onChange={handleChange}>
          <Tab label="1 año" />
          <Tab label="5 años" />
          <Tab label="10 años" />
        </MuiTabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
          <Alert severity="error" sx={{marginBottom:2}}>
            <AlertTitle>Boric-Marcel te están quitando</AlertTitle>
            <strong><Chip label={`$${formatAmount(results.first.difference)}`} color="error" size="small" /></strong>
          </Alert>
        <Box sx={{display:{xs:'block', sm:'flex'}, justifyContent:'space-around'}}>
          <Card
            title="Modelo actual"
            content={
              <Box sx={{ display: "flex", flexDirection: "column"}}>
                <Typography variant="body2" color="text.secondary">
                  Cotización: <strong>${formatAmount(results.first.actual.cotization)}</strong>
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Aporte a cuenta: <strong>${formatAmount(results.first.actual.contribution)}</strong>
                </Typography>
              </Box>
            }
          />
          <Card sx={{margin:{xs:'20px 0', sm:0}}}
            title="Modelo Boric-Marcel"
            content={
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body2" color="text.secondary">
                  Cotización: <strong>${formatAmount(results.first.boric.cotization)}</strong>
                </Typography>
                <Box sx={{display:'flex', alignItems:'center'}}>
                  <Typography variant="body2" color="text.secondary">
                    Aporte a cuenta:{'\xa0'}
                  </Typography>
                  <strong><Chip label={`$${formatAmount(results.first.boric.contribution)}`} color="error" size="small" /></strong>
                </Box>
              </Box>
            }
          />
          <Card className="shadow"
            title="Modelo Franco Parisi"
            content={
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body2" color="text.secondary">
                  Cotización: <strong>${formatAmount(results.first.parisi.cotization)}</strong>
                </Typography>
                <Box sx={{display:'flex', alignItems:'center'}}>
                  <Typography variant="body2" color="text.secondary">
                    Aporte a cuenta:{'\xa0'}
                  </Typography>
                  <strong><Chip label={`$${formatAmount(results.first.parisi.contribution)}`} color="success" size="small" /></strong>
                </Box>
              </Box>
            }
          />
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
          <Alert severity="error" sx={{marginBottom:2}}>
          <AlertTitle>Boric-Marcel te están quitando</AlertTitle>
            <strong><Chip label={`$${formatAmount(results.fifth.difference)}`} color="error" size="small" /></strong>
          </Alert>
          <Box sx={{display:{xs:'block', sm:'flex'}, justifyContent:'space-around'}}>
            <Card
            title="Modelo actual"
            content={
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body2" color="text.secondary">
                  Cotización: <strong>${formatAmount(results.fifth.actual.cotization)}</strong>
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Aporte a cuenta: <strong>${formatAmount(results.fifth.actual.contribution)}</strong>
                </Typography>
              </Box>
            }
          />
            <Card sx={{margin:{xs:'20px 0', sm:0}}}
              title="Modelo Boric-Marcel"
              content={
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography variant="body2" color="text.secondary">
                    Cotización: <strong>${formatAmount(results.fifth.boric.cotization)}</strong>
                  </Typography>
                  <Box sx={{display:'flex', alignItems:'center'}}>
                    <Typography variant="body2" color="text.secondary">
                      Aporte a cuenta:{'\xa0'}
                    </Typography>
                    <strong><Chip label={`$${formatAmount(results.fifth.boric.contribution)}`} color="error" size="small" /></strong>
                  </Box>
                </Box>
              }
            />
          <Card className="shadow"
            title="Modelo Franco Parisi"
            content={
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body2" color="text.secondary">
                  Cotización: <strong>${formatAmount(results.fifth.parisi.cotization)}</strong>
                </Typography>
                <Box sx={{display:'flex', alignItems:'center'}}>
                  <Typography variant="body2" color="text.secondary">
                    Aporte a cuenta:{"\xa0"}
                  </Typography>
                  <strong><Chip label={`$${formatAmount(results.fifth.parisi.contribution)}`} color="success" size="small" /></strong>
                </Box>
              </Box>
            }
          />
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Alert severity="error" sx={{marginBottom:2}}>
        <AlertTitle>Boric-Marcel te están quitando</AlertTitle>
            <strong><Chip label={`$${formatAmount(results.tenth.difference)}`} color="error" size="small" /></strong>
        </Alert>
        <Box sx={{display:{xs:'block', sm:'flex'}, justifyContent:'space-around'}}>
        <Card
          title="Modelo actual"
          content={
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body2" color="text.secondary">
                Cotización: <strong>${formatAmount(results.tenth.actual.cotization)}</strong>
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Aporte a cuenta: <strong>${formatAmount(results.tenth.actual.contribution)}</strong>
              </Typography>
            </Box>
          }
        />
          <Card sx={{margin:{xs:'20px 0', sm:0}}}
            title="Modelo Boric-Marcel"
            content={
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body2" color="text.secondary">
                  Cotización: <strong>${formatAmount(results.tenth.boric.cotization)}</strong>
                </Typography>
                <Box sx={{display:'flex', alignItems:'center'}}>
                  <Typography variant="body2" color="text.secondary">
                    Aporte a cuenta:{"\xa0"}
                  </Typography>
                  <strong><Chip label={`$${formatAmount(results.tenth.boric.contribution)}`} color="error" size="small" /></strong>
                </Box>
              </Box>
            }
          />
        <Card className="shadow"
          title="Modelo Franco Parisi"
          content={
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body2" color="text.secondary">
                Cotización: <strong>${formatAmount(results.tenth.parisi.cotization)}</strong>
              </Typography>
              <Box sx={{display:'flex', alignItems:'center'}}>
                <Typography variant="body2" color="text.secondary">
                  Aporte a cuenta:{"\xa0"}
                </Typography>
                <strong><Chip label={`$${formatAmount(results.tenth.parisi.contribution)}`} color="success" size="small" /></strong>
              </Box>
            </Box>
          }
        />
        </Box>
      </CustomTabPanel>
    </Box>
  );
}

export default Tabs